{
  "welcome": {
    "title": "WrongStack'a hoş geldiniz",
    "subtitle": "Başlamak için bir sağlayıcı bağlayın.",
    "heroTitle": "Nereden başlamak istersin?",
    "heroTitleInProject": "{{name}} içinde nereden başlamak istersin?",
    "heroSubtitle": "Vekil, projenize bağlı ve dosyaları okumaya, düzenlemeye, komut çalıştırmaya, kod tabanında arama yapmaya, yapılacakları takip etmeye ve oturumlar arasında bağlamı hatırlamaya hazır. Aşağıdan bir başlangıç promptu seçin, kendiniz yazın veya tüm komut paleti için / yazın.",
    "workingDirectory": "Çalışma dizini: {{cwd}}",
    "noKeyTitle": "Henüz API anahtarı yapılandırılmadı",
    "noKeyBody": "Mesaj göndermeden önce Ayarlar'dan bir sağlayıcı kaydedin — yoksa vekilin bağlanacağı biri olmaz. Anthropic, OpenAI, Google ve OpenAI uyumlu herhangi bir uç nokta çalışır.",
    "openSettings": "Ayarları aç",
    "pickBackUp": "Kaldığın yerden devam et",
    "recentPrompts": "Son promptlar",
    "quickCommands": "Hızlı komutlar",
    "startingPrompts": "Başlangıç promptları",
    "shufflePrompts": "Karıştır",
    "shufflePromptsHint": "Yeni bir başlangıç promptları seti göster",
    "empty": "(boş)",
    "card": {
      "understand": {
        "title": "Anla",
        "hint": "Kod tabanını keşfet ve analiz et"
      },
      "create": {
        "title": "Oluştur",
        "hint": "Yeni özellikler ve işlevler oluştur"
      },
      "investigate": {
        "title": "Araştır",
        "hint": "Sorunları ayıkla ve kök nedenleri bul"
      },
      "improve": {
        "title": "Geliştir",
        "hint": "Mevcut kodu yeniden düzenle ve iyileştir"
      }
    },
    "slashRef": {
      "help": "tüm slash komutlarını listele",
      "diag": "çalışma zamanı tanılamaları",
      "stats": "token · önbellek · maliyet · geçen süre",
      "tools": "kayıtlı araçları göster",
      "memory": "hatırlanan notları göster",
      "compact": "bağlamı daralt",
      "clear": "mevcut bağlamı sil",
      "new": "temiz oturum"
    }
  },
  "provider": {
    "heading": "Bir sağlayıcı seçin",
    "keyPlaceholder": "API anahtarınızı yapıştırın",
    "connect": "Bağlan",
    "connected": "Bağlandı"
  },
  "screen": {
    "header": {
      "title": "WrongStack'a hoş geldiniz",
      "subtitle": "Başlamak için en az bir API anahtarı ekleyin",
      "continue": "Devam et"
    },
    "steps": {
      "addKeys": "API Anahtarları Ekle",
      "pickModel": "Model Seç",
      "start": "Başla",
      "keys": "Anahtarlar"
    },
    "security": {
      "title": "Anahtarlarınız makinenizde kalır",
      "body": "API anahtarları şifrelenir ve yerel olarak saklanır. Yalnızca sağlayıcının API uç noktasına gönderilir — bize veya üçüncü taraflara asla."
    },
    "errors": {
      "backendUnreachable": "Arka uca ulaşılamıyor",
      "backendNotResponding": "Arka uç yanıt vermiyor. Çökmüş veya bağlantı kopmuş olabilir.",
      "retry": "Yeniden dene",
      "modelSwitchTimeout": "Model geçişi zaman aşamına uğradı. Lütfen tekrar deneyin.",
      "noModels": "Kullanılabilir model yok. API anahtarınızı kontrol edip tekrar deneyin."
    },
    "providers": {
      "popular": "Popüler Sağlayıcılar",
      "more": "Diğer Sağlayıcılar",
      "selfHosted": "Kendi sunucunuzda",
      "updating": "Güncelleniyor...",
      "refresh": "Yenile",
      "refreshTitle": "Sağlayıcı listesini yenile",
      "modelsAvailable_one": "{{count}} model kullanılabilir",
      "modelsAvailable_other": "{{count}} model kullanılabilir",
      "catalogDescription": "{{family}} · {{count}} model"
    },
    "start": {
      "pickAndStart": "Bir model seç ve başla",
      "addMoreKeys": "← Daha fazla anahtar ekle",
      "chooseProvider": "Bir Sağlayıcı Seç",
      "chooseModel": "Bir Model Seç",
      "modelsFor": "{{provider}} için kullanılabilir modeller",
      "activeKeys_one": "{{count}} etkin anahtar",
      "activeKeys_other": "{{count}} etkin anahtar",
      "startSession": "Oturumu Başlat"
    },
    "card": {
      "keySaved": "Anahtar kaydedildi",
      "referral": "Davet",
      "save": "Kaydet",
      "getKey": "API anahtarınızı alın",
      "copied": "Kopyalandı",
      "copyReferral": "Davet bağlantısını kopyala",
      "share": "Paylaş",
      "qrAlt": "{{name}} davet QR kodu"
    },
    "share": {
      "title": "{{name}} davetini paylaş",
      "description": "Bu davet bağlantısını arkadaşlarınızla paylaşın ve ödüller kazanın!",
      "hint": "Paylaşmak için QR kodunu tarayın veya bağlantıyı kopyalayın",
      "twitter": "X/Twitter'da paylaş",
      "linkedin": "LinkedIn'de paylaş",
      "telegram": "Telegram'da paylaş",
      "whatsapp": "WhatsApp'ta paylaş",
      "reddit": "Reddit'te paylaş",
      "facebook": "Facebook'ta paylaş",
      "email": "E-posta ile paylaş"
    },
    "custom": {
      "title": "Özel / Kendi Sunucunuzda Sağlayıcı",
      "description": "Herhangi bir OpenAI uyumlu uç nokta ekleyin (Ollama, vLLM, Together vb.)",
      "localServers": "Yerel sunucular — doldurmak için tıklayın",
      "providerId": "Sağlayıcı kimliği *",
      "family": "Aile",
      "familyOpenAiCompatible": "OpenAI Uyumlu",
      "baseUrl": "Temel URL (isteğe bağlı)",
      "apiKey": "API Anahtarı (isteğe bağlı — bazı yerel sağlayıcılar bunu gerektirmez)",
      "apiKeyPlaceholder": "API anahtarı (gerekliyse)",
      "add": "Sağlayıcı Ekle"
    },
    "time": {
      "justNow": "az önce",
      "secondsAgo": "{{count}} sn önce",
      "minutesAgo": "{{count}} dk önce",
      "hoursAgo": "{{count}} sa önce",
      "daysAgo": "{{count}} gün önce"
    },
    "toasts": {
      "keySaved": "{{name}} API anahtarı kaydedildi",
      "keySaveFailed": "{{name}} API anahtarı kaydedilemedi",
      "referralCopied": "Davet bağlantısı panoya kopyalandı",
      "referralCopyFailed": "Davet bağlantısı kopyalanamadı",
      "providerAdded": "\"{{id}}\" sağlayıcısı eklendi",
      "providerAddFailed": "Sağlayıcı eklenemedi",
      "providersLoadedNew": "{{count}} sağlayıcı yüklendi ({{diff}} yeni)",
      "providersLoadedRemoved": "{{count}} sağlayıcı yüklendi ({{diff}} kaldırıldı)",
      "providersLoadedNoChanges": "{{count}} sağlayıcı yüklendi (değişiklik yok)",
      "providersRefreshFailed": "Sağlayıcılar yenilenemedi"
    }
  }
}
